import {
  AdminDoctorDetailResponse,
  AdminDoctorLicence,
  DoctorAdminActionAuditEntry,
  DoctorAdminSearchParams,
  DoctorLicenceGrantHistoryEntry,
  DoctorPublicResponse,
  GrantFreeAccessPayload,
  SmsStatusResponse,
} from "../types/doctorAdmin.definition";
import { SearchResponse } from "../types/search.definition";
import {
  requestGetAdminDoctorDetail,
  requestGetAdminDoctorSmsStatus,
  requestGetDoctorAdminActionAudit,
  requestGetDoctorGrantHistory,
  requestGrantFreeAccess,
  requestSearchAdminDoctors,
} from "../webclients/doctorAdmin.client";

export const doctorAdminApi = {
  searchDoctors: async (
    params: DoctorAdminSearchParams
  ): Promise<SearchResponse<DoctorPublicResponse>> => {
    const response = await requestSearchAdminDoctors(params);
    return response.data as SearchResponse<DoctorPublicResponse>;
  },

  getDoctorDetail: async (
    doctorId: number | string
  ): Promise<AdminDoctorDetailResponse> => {
    const response = await requestGetAdminDoctorDetail(doctorId);
    return response.data as AdminDoctorDetailResponse;
  },

  grantFreeAccess: async (
    doctorId: number | string,
    data: GrantFreeAccessPayload
  ): Promise<AdminDoctorLicence> => {
    const response = await requestGrantFreeAccess(doctorId, data);
    return response.data as AdminDoctorLicence;
  },

  getGrantHistory: async (
    doctorId: number | string
  ): Promise<DoctorLicenceGrantHistoryEntry[]> => {
    const response = await requestGetDoctorGrantHistory(doctorId);
    return response.data as DoctorLicenceGrantHistoryEntry[];
  },

  getDoctorSmsStatus: async (
    doctorId: number | string
  ): Promise<SmsStatusResponse> => {
    const response = await requestGetAdminDoctorSmsStatus(doctorId);
    return response.data as SmsStatusResponse;
  },

  getAdminActionAudit: async (
    doctorId: number | string
  ): Promise<DoctorAdminActionAuditEntry[]> => {
    const response = await requestGetDoctorAdminActionAudit(doctorId);
    return response.data as DoctorAdminActionAuditEntry[];
  },
};
